/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type VehicleGroup,
    VehicleGroupFromJSON,
    VehicleGroupToJSON,
} from '../models/VehicleGroup';
import {
    type VehicleGroupCreate,
    VehicleGroupCreateFromJSON,
    VehicleGroupCreateToJSON,
} from '../models/VehicleGroupCreate';
import {
    type VehicleGroupSortKey,
    VehicleGroupSortKeyFromJSON,
    VehicleGroupSortKeyToJSON,
} from '../models/VehicleGroupSortKey';
import {
    type VehicleGroupUpdate,
    VehicleGroupUpdateFromJSON,
    VehicleGroupUpdateToJSON,
} from '../models/VehicleGroupUpdate';

export interface VehicleGroupsCreateVehicleGroupRequest {
    vehicleGroupCreate: VehicleGroupCreate;
}

export interface VehicleGroupsDeleteVehicleGroupRequest {
    vehicleGroupId: string;
}

export interface VehicleGroupsListVehicleGroupsRequest {
    pageSize: number;
    search?: string | null;
    vehicleId?: string | null;
    userGroupIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleGroupSortKey;
}

export interface VehicleGroupsListVehicleGroupsMetadataRequest {
    pageSize: number;
    search?: string | null;
    vehicleId?: string | null;
    userGroupIds?: Array<string> | null;
}

export interface VehicleGroupsReadVehicleGroupRequest {
    vehicleGroupId: string;
}

export interface VehicleGroupsUpdateVehicleGroupRequest {
    vehicleGroupId: string;
    vehicleGroupUpdate: VehicleGroupUpdate;
}

export interface VehicleGroupsValidateCreateVehicleGroupRequest {
    vehicleGroupCreate: VehicleGroupCreate;
}

export interface VehicleGroupsValidateUpdateVehicleGroupRequest {
    vehicleGroupId: string;
    vehicleGroupUpdate: VehicleGroupUpdate;
}

/**
 * VehicleGroupsApi - interface
 * 
 * @export
 * @interface VehicleGroupsApiInterface
 */
export interface VehicleGroupsApiInterface {
    /**
     * Creates request options for vehicleGroupsCreateVehicleGroup without sending the request
     * @param {VehicleGroupCreate} vehicleGroupCreate 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsCreateVehicleGroupRequestOpts(requestParameters: VehicleGroupsCreateVehicleGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle group.
     * @summary Create a vehicle group
     * @param {VehicleGroupCreate} vehicleGroupCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsCreateVehicleGroupRaw(requestParameters: VehicleGroupsCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroup>>;

    /**
     * Create a new vehicle group.
     * Create a vehicle group
     */
    vehicleGroupsCreateVehicleGroup(requestParameters: VehicleGroupsCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroup>;

    /**
     * Creates request options for vehicleGroupsDeleteVehicleGroup without sending the request
     * @param {string} vehicleGroupId 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsDeleteVehicleGroupRequestOpts(requestParameters: VehicleGroupsDeleteVehicleGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the vehicle group with the given ID.
     * @summary Delete a vehicle group
     * @param {string} vehicleGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsDeleteVehicleGroupRaw(requestParameters: VehicleGroupsDeleteVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the vehicle group with the given ID.
     * Delete a vehicle group
     */
    vehicleGroupsDeleteVehicleGroup(requestParameters: VehicleGroupsDeleteVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleGroupsListVehicleGroups without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [vehicleId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleGroupSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsListVehicleGroupsRequestOpts(requestParameters: VehicleGroupsListVehicleGroupsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the vehicle group present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. Optionally filter by assignment to the given vehicle.
     * @summary List vehicle group
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [vehicleId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleGroupSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsListVehicleGroupsRaw(requestParameters: VehicleGroupsListVehicleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleGroup>>>;

    /**
     * Lists all the vehicle group present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. Optionally filter by assignment to the given vehicle.
     * List vehicle group
     */
    vehicleGroupsListVehicleGroups(requestParameters: VehicleGroupsListVehicleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleGroup>>;

    /**
     * Creates request options for vehicleGroupsListVehicleGroupsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [vehicleId] 
     * @param {Array<string>} [userGroupIds] 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsListVehicleGroupsMetadataRequestOpts(requestParameters: VehicleGroupsListVehicleGroupsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Vehicle group listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [vehicleId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsListVehicleGroupsMetadataRaw(requestParameters: VehicleGroupsListVehicleGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle group listing metadata
     */
    vehicleGroupsListVehicleGroupsMetadata(requestParameters: VehicleGroupsListVehicleGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for vehicleGroupsReadVehicleGroup without sending the request
     * @param {string} vehicleGroupId 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsReadVehicleGroupRequestOpts(requestParameters: VehicleGroupsReadVehicleGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle group specified by the given ID.
     * @summary Get a single vehicle group
     * @param {string} vehicleGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsReadVehicleGroupRaw(requestParameters: VehicleGroupsReadVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroup>>;

    /**
     * Returns the vehicle group specified by the given ID.
     * Get a single vehicle group
     */
    vehicleGroupsReadVehicleGroup(requestParameters: VehicleGroupsReadVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroup>;

    /**
     * Creates request options for vehicleGroupsUpdateVehicleGroup without sending the request
     * @param {string} vehicleGroupId 
     * @param {VehicleGroupUpdate} vehicleGroupUpdate 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsUpdateVehicleGroupRequestOpts(requestParameters: VehicleGroupsUpdateVehicleGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the vehicle group specified by the given ID.
     * @summary Update vehicle group
     * @param {string} vehicleGroupId 
     * @param {VehicleGroupUpdate} vehicleGroupUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsUpdateVehicleGroupRaw(requestParameters: VehicleGroupsUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroup>>;

    /**
     * Update the vehicle group specified by the given ID.
     * Update vehicle group
     */
    vehicleGroupsUpdateVehicleGroup(requestParameters: VehicleGroupsUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroup>;

    /**
     * Creates request options for vehicleGroupsValidateCreateVehicleGroup without sending the request
     * @param {VehicleGroupCreate} vehicleGroupCreate 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsValidateCreateVehicleGroupRequestOpts(requestParameters: VehicleGroupsValidateCreateVehicleGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new vehicle group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a vehicle group
     * @param {VehicleGroupCreate} vehicleGroupCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsValidateCreateVehicleGroupRaw(requestParameters: VehicleGroupsValidateCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new vehicle group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle group
     */
    vehicleGroupsValidateCreateVehicleGroup(requestParameters: VehicleGroupsValidateCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleGroupsValidateUpdateVehicleGroup without sending the request
     * @param {string} vehicleGroupId 
     * @param {VehicleGroupUpdate} vehicleGroupUpdate 
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsValidateUpdateVehicleGroupRequestOpts(requestParameters: VehicleGroupsValidateUpdateVehicleGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given vehicle group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate vehicle group update
     * @param {string} vehicleGroupId 
     * @param {VehicleGroupUpdate} vehicleGroupUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupsApiInterface
     */
    vehicleGroupsValidateUpdateVehicleGroupRaw(requestParameters: VehicleGroupsValidateUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given vehicle group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle group update
     */
    vehicleGroupsValidateUpdateVehicleGroup(requestParameters: VehicleGroupsValidateUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VehicleGroupsApi extends runtime.BaseAPI implements VehicleGroupsApiInterface {

    /**
     * Creates request options for vehicleGroupsCreateVehicleGroup without sending the request
     */
    async vehicleGroupsCreateVehicleGroupRequestOpts(requestParameters: VehicleGroupsCreateVehicleGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupCreate',
                'Required parameter "vehicleGroupCreate" was null or undefined when calling vehicleGroupsCreateVehicleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupCreateToJSON(requestParameters['vehicleGroupCreate']),
        };
    }

    /**
     * Create a new vehicle group.
     * Create a vehicle group
     */
    async vehicleGroupsCreateVehicleGroupRaw(requestParameters: VehicleGroupsCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroup>> {
        const requestOptions = await this.vehicleGroupsCreateVehicleGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleGroupFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle group.
     * Create a vehicle group
     */
    async vehicleGroupsCreateVehicleGroup(requestParameters: VehicleGroupsCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroup> {
        const response = await this.vehicleGroupsCreateVehicleGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupsDeleteVehicleGroup without sending the request
     */
    async vehicleGroupsDeleteVehicleGroupRequestOpts(requestParameters: VehicleGroupsDeleteVehicleGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupId',
                'Required parameter "vehicleGroupId" was null or undefined when calling vehicleGroupsDeleteVehicleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/{vehicle_group_id}`;
        urlPath = urlPath.replace('{vehicle_group_id}', encodeURIComponent(String(requestParameters['vehicleGroupId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the vehicle group with the given ID.
     * Delete a vehicle group
     */
    async vehicleGroupsDeleteVehicleGroupRaw(requestParameters: VehicleGroupsDeleteVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleGroupsDeleteVehicleGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the vehicle group with the given ID.
     * Delete a vehicle group
     */
    async vehicleGroupsDeleteVehicleGroup(requestParameters: VehicleGroupsDeleteVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleGroupsDeleteVehicleGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleGroupsListVehicleGroups without sending the request
     */
    async vehicleGroupsListVehicleGroupsRequestOpts(requestParameters: VehicleGroupsListVehicleGroupsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleGroupsListVehicleGroups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['vehicleId'] != null) {
            queryParameters['vehicle_id'] = requestParameters['vehicleId'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the vehicle group present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. Optionally filter by assignment to the given vehicle.
     * List vehicle group
     */
    async vehicleGroupsListVehicleGroupsRaw(requestParameters: VehicleGroupsListVehicleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleGroup>>> {
        const requestOptions = await this.vehicleGroupsListVehicleGroupsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleGroupFromJSON));
    }

    /**
     * Lists all the vehicle group present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. Optionally filter by assignment to the given vehicle.
     * List vehicle group
     */
    async vehicleGroupsListVehicleGroups(requestParameters: VehicleGroupsListVehicleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleGroup>> {
        const response = await this.vehicleGroupsListVehicleGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupsListVehicleGroupsMetadata without sending the request
     */
    async vehicleGroupsListVehicleGroupsMetadataRequestOpts(requestParameters: VehicleGroupsListVehicleGroupsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleGroupsListVehicleGroupsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['vehicleId'] != null) {
            queryParameters['vehicle_id'] = requestParameters['vehicleId'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle group listing metadata
     */
    async vehicleGroupsListVehicleGroupsMetadataRaw(requestParameters: VehicleGroupsListVehicleGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.vehicleGroupsListVehicleGroupsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle group listing metadata
     */
    async vehicleGroupsListVehicleGroupsMetadata(requestParameters: VehicleGroupsListVehicleGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.vehicleGroupsListVehicleGroupsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupsReadVehicleGroup without sending the request
     */
    async vehicleGroupsReadVehicleGroupRequestOpts(requestParameters: VehicleGroupsReadVehicleGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupId',
                'Required parameter "vehicleGroupId" was null or undefined when calling vehicleGroupsReadVehicleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/{vehicle_group_id}`;
        urlPath = urlPath.replace('{vehicle_group_id}', encodeURIComponent(String(requestParameters['vehicleGroupId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle group specified by the given ID.
     * Get a single vehicle group
     */
    async vehicleGroupsReadVehicleGroupRaw(requestParameters: VehicleGroupsReadVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroup>> {
        const requestOptions = await this.vehicleGroupsReadVehicleGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleGroupFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle group specified by the given ID.
     * Get a single vehicle group
     */
    async vehicleGroupsReadVehicleGroup(requestParameters: VehicleGroupsReadVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroup> {
        const response = await this.vehicleGroupsReadVehicleGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupsUpdateVehicleGroup without sending the request
     */
    async vehicleGroupsUpdateVehicleGroupRequestOpts(requestParameters: VehicleGroupsUpdateVehicleGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupId',
                'Required parameter "vehicleGroupId" was null or undefined when calling vehicleGroupsUpdateVehicleGroup().'
            );
        }

        if (requestParameters['vehicleGroupUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupUpdate',
                'Required parameter "vehicleGroupUpdate" was null or undefined when calling vehicleGroupsUpdateVehicleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/{vehicle_group_id}`;
        urlPath = urlPath.replace('{vehicle_group_id}', encodeURIComponent(String(requestParameters['vehicleGroupId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupUpdateToJSON(requestParameters['vehicleGroupUpdate']),
        };
    }

    /**
     * Update the vehicle group specified by the given ID.
     * Update vehicle group
     */
    async vehicleGroupsUpdateVehicleGroupRaw(requestParameters: VehicleGroupsUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroup>> {
        const requestOptions = await this.vehicleGroupsUpdateVehicleGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleGroupFromJSON(jsonValue));
    }

    /**
     * Update the vehicle group specified by the given ID.
     * Update vehicle group
     */
    async vehicleGroupsUpdateVehicleGroup(requestParameters: VehicleGroupsUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroup> {
        const response = await this.vehicleGroupsUpdateVehicleGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupsValidateCreateVehicleGroup without sending the request
     */
    async vehicleGroupsValidateCreateVehicleGroupRequestOpts(requestParameters: VehicleGroupsValidateCreateVehicleGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupCreate',
                'Required parameter "vehicleGroupCreate" was null or undefined when calling vehicleGroupsValidateCreateVehicleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupCreateToJSON(requestParameters['vehicleGroupCreate']),
        };
    }

    /**
     * Validate data for a new vehicle group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle group
     */
    async vehicleGroupsValidateCreateVehicleGroupRaw(requestParameters: VehicleGroupsValidateCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleGroupsValidateCreateVehicleGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new vehicle group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle group
     */
    async vehicleGroupsValidateCreateVehicleGroup(requestParameters: VehicleGroupsValidateCreateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleGroupsValidateCreateVehicleGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleGroupsValidateUpdateVehicleGroup without sending the request
     */
    async vehicleGroupsValidateUpdateVehicleGroupRequestOpts(requestParameters: VehicleGroupsValidateUpdateVehicleGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupId',
                'Required parameter "vehicleGroupId" was null or undefined when calling vehicleGroupsValidateUpdateVehicleGroup().'
            );
        }

        if (requestParameters['vehicleGroupUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupUpdate',
                'Required parameter "vehicleGroupUpdate" was null or undefined when calling vehicleGroupsValidateUpdateVehicleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_groups/{vehicle_group_id}/validate`;
        urlPath = urlPath.replace('{vehicle_group_id}', encodeURIComponent(String(requestParameters['vehicleGroupId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupUpdateToJSON(requestParameters['vehicleGroupUpdate']),
        };
    }

    /**
     * Validate data for updating the given vehicle group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle group update
     */
    async vehicleGroupsValidateUpdateVehicleGroupRaw(requestParameters: VehicleGroupsValidateUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleGroupsValidateUpdateVehicleGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given vehicle group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle group update
     */
    async vehicleGroupsValidateUpdateVehicleGroup(requestParameters: VehicleGroupsValidateUpdateVehicleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleGroupsValidateUpdateVehicleGroupRaw(requestParameters, initOverrides);
    }

}
